import { gql } from "@apollo/client";


export const GET_APPRECIATION = gql`
  query getAppreciation($employeeName: String) {
    getAppreciation(employeeName: $employeeName) {
      title
      department
      employeeName
      inputAppreciation
      createdBy
      employeeDetails {
        firstName
        lastName
      }
      employeeDt {
        firstName
        lastName
      }
      projectLevel
      orgLevel
    }
  }
`;

export const APPRECIATIONBY_DEPT = gql`
  query GetAppreciationbydept($department: String) {
    getAppreciationbydept(department: $department) {
      department
      createdBy
      createdAt
      Id
      employeeDetails {
        firstName
        lastName
      }
      employeeName
      inputAppreciation
      title
    }
  }
`;

export const GET_ALL_APPRECIATION = gql`
  query getAllAppreciation {
    getAllAppreciation {
      title
      department
      employeeName
      projDetails {
        employeeName
      }
      inputAppreciation
      employeeDetails {
        firstName
        lastName
      }
      createdAt
      orgLevel
    }
  }
`;
